export const scoreTitle = 'Správné odpovědi:'
export const nextButton = 'Další otázka'
export const lastButton = 'Vyhodnocení'
export const correctAnswer = {
  isCorrect: true,
  image: require('@/assets/thumb-up.svg'),
  title: 'Správná odpověď',
}
export const wrongAnswer = {
  isCorrect: false,
  image: require('@/assets/thumb-down.svg'),
  title: 'Špatná odpověď',
}
export const questions = [
  {
    question: 'Ve kterém roce byl vyroben první čistě syntetický plast?',
    answer: 0,
    options: ['1907', '1953'],
    description:
      'Belgický chemik Leo Baekeland byl průkopníkem prvního čistě syntetického plastu „bakelit“. Ten vznikl spojením dvou chemikálií formaldehydu&nbsp;a fenolu.',
    image: require('@/assets/img01.svg'),
  },
  {
    question: 'Co to vlastně plasty jsou?',
    answer: 1,
    options: ['Zpracované lithium', 'Typ polymerů'],
    description:
      'Makromolekuly, které mají stovky až tisíce spojení&nbsp;v každém řetězci&nbsp;a vynikají zejména ve své síle&nbsp;a pevnosti. Tento typ polymerů je tvárný&nbsp;a dá se za tepla ohýbat.',
    image: require('@/assets/img02.svg'),
  },
  {
    question: 'Jaká je v současnosti nejdůležitější surovina využívaná při výrobě plastů?',
    answer: 0,
    options: ['Ropa', 'Pšenice lisovaná speciálními postupy'],
    description:
      'Ačkoliv lze plasty vyrobit&nbsp;i alternativními postupy&nbsp;z jiných surovin, ropa stále zůstává při výrobě plastů nejdůležitější surovinou.',
    image: require('@/assets/img03.svg'),
  },
  {
    question: 'Co je to plasticita?',
    answer: 0,
    options: ['Poddajnost&nbsp;a tvarovatelnost', 'Slepení výrobních dílů'],
    description: 'Plasticita, českým synonymem tvárnost, je mechanická vlastnost materiálu, která je jednou z hlavních silných stránek plastů.',
    image: require('@/assets/img04.svg'),
  },
  {
    question: 'Jak je zpracováván recyklovaný plast?',
    answer: 1,
    options: ['Je míchán&nbsp;s ostatními odpady', 'Je umyt&nbsp;a rozdrcen na malé kousky'],
    description: 'Plasty, které recyklujeme, jsou umyty a rozdrceny. Následný produkt nazývaný recyklát je zpracováván ve formě granulí.',
    image: require('@/assets/img05.svg'),
  },
  {
    question: 'Co je na plastech pozitivního?',
    answer: 0,
    options: ['Levná výroba, zpracovatelnost&nbsp;a unikátní vlastnosti', 'Plasty jsou zpravidla žluté&nbsp;a přispívají&nbsp;k lepší náladě'],
    description:
      'Ne že by plasty nemohly teoreticky přispět&nbsp;k dobré náladě, ale jejich hlavními benefity jsou cena, využitelnost&nbsp;a specifické vlastnosti.',
    image: require('@/assets/img06.svg'),
  },
  {
    question: 'Jakou zkratkou se nazývá nejčastěji využívaný bioplast?',
    answer: 0,
    options: ['PLA', 'PLB'],
    description:
      'Bioplasty jsou materiály vytvořené z biomasy (např. kukuřice nebo cukrová třtina). Většina z nich je biologicky rozložitelná.',
    image: require('@/assets/img07.svg'),
  },
  {
    question: 'Co patří do žluté popelnice?',
    answer: 1,
    options: ['Mastné obaly, obaly od žíravin nebo barev', 'Plasty&nbsp;a obaly, které nejsou znečištěné'],
    description: 'Ne všechno, co je&nbsp;z plastu, automaticky patří do žlutých kontejnerů. Dejte pozor hlavně na mastnotu&nbsp;a chemické látky.',
    image: require('@/assets/img08.svg'),
  },
  {
    question: 'Obsahují moderní auta plasty?',
    answer: 0,
    options: ['Ano', 'Ne'],
    description:
      'Většina aut je složena přibližně jednou třetinou z plastů. Díky velmi nízké hmotnosti plastových částí se také snižuje celková spotřeba paliva.',
    image: require('@/assets/img09.svg'),
  },
  {
    question: 'Kolik lidí v České republice třídí?',
    answer: 0,
    options: ['Asi&nbsp;72&nbsp;%', 'Asi&nbsp;27&nbsp;%'],
    description:
      'Čím více&nbsp;z nás bude aktivně třídit odpad, který produkujeme, tím lépe nám bude. A to hned&nbsp;v mnoha aspektech života.',
    image: require('@/assets/img10.svg'),
  },
]
export const resultMessages = [
  {
    min: 0,
    max: 2,
    title: 'Jak se to stalo?',
    message:
      'Že vy jste to jen tak prolítli? Příště to chce dávat víc pozor…',
  },
  {
    min: 3,
    max: 5,
    title: 'Solidní základ',
    message:
      'Na vědecký diplom to sice není, ale něco o plastech už přeci jen víte.',
  },
  {
    min: 6,
    max: 8,
    title: 'Krásná práce!',
    message:
      'Na nejvyšší metu chyběl jen kousek. Plasty máte zmáknuté. Pokračujte v dobré práci.',
  },
  {
    min: 9,
    max: 10,
    title: 'Fanplastické!',
    message: 'V plastech jste jednička! Chválíme, parádní přehled.',
  },
]
